export default {
    logout: 'ออกจากระบบ'
}
